module.exports = __webpack_public_path__ + "static/media/bytt-no-4.24e4777b.mp3";